import * as authenticate from 'api/authentificationAPI';

// Repli quand l'API ne renvoie pas de message exploitable (erreur interceptée
// par un proxy, réponse tronquée...). Le backend, lui, renvoie toujours un
// couple error / message que l'on privilégie.
const HTTP_ERRORS = {
    400: ['INVALID_INPUT', 'Les données saisies sont invalides. Veuillez vérifier votre email et mot de passe.'],
    401: ['INVALID_CREDENTIALS', 'Email ou mot de passe incorrect.'],
    403: ['ACCESS_FORBIDDEN', 'Accès refusé. Veuillez contacter votre administrateur.'],
    429: ['RATE_LIMIT', 'Trop de tentatives de connexion. Veuillez réessayer dans 15 minutes.'],
    502: ['SERVICE_UNAVAILABLE', 'Le service d\'authentification est temporairement indisponible. Veuillez réessayer plus tard.'],
    503: ['SERVICE_UNAVAILABLE', 'Le service d\'authentification est temporairement indisponible. Veuillez réessayer plus tard.'],
    504: ['TIMEOUT', 'Le serveur d\'authentification ne répond pas. Veuillez réessayer dans quelques instants.'],
};

const NETWORK_ERRORS = {
    ECONNABORTED: ['TIMEOUT', 'La connexion a expiré. Vérifiez votre connexion internet et réessayez.'],
    ETIMEDOUT: ['TIMEOUT', 'La connexion a expiré. Vérifiez votre connexion internet et réessayez.'],
};

const failure = ([error, message]) => ({ success: false, error, message });

// Traduction des erreurs renvoyées par l'API en messages affichables.
const errorFromResponse = (error) => {
    const data = error.response?.data;
    if (data?.error && data?.message) {
        return { success: false, error: data.error, message: data.message };
    }

    if (error.response) {
        return failure(HTTP_ERRORS[error.response.status] || ['UNKNOWN_ERROR', 'Une erreur inattendue s\'est produite. Veuillez réessayer.']);
    }

    // Erreurs réseau (pas de réponse du serveur)
    return failure(NETWORK_ERRORS[error.code] || ['NETWORK_ERROR', 'Impossible de se connecter au serveur. Vérifiez votre connexion internet.']);
};

// Récupère l'identité de la session en cours. Remplace l'ancien couple
// cookie `encodedEmail` + /decodeEmail : l'email et les rôles viennent
// désormais d'un jeton signé que le navigateur ne peut pas fabriquer.
// Retourne null quand aucune session n'est ouverte, ce qui n'est pas une erreur.
export async function getSession() {
    try {
        const response = await authenticate.getSession();
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            return null;
        }
        console.error('Erreur lors de la récupération de la session :', error);
        return null;
    }
}

// Fonction pour gérer la connexion
export async function login(email, password) {
    try {
        const response = await authenticate.login(email, password);
        return { success: true, email: response.data.email, roles: response.data.roles };
    } catch (error) {
        console.error("Erreur lors de l'authentification :", error);
        return errorFromResponse(error);
    }
}

export async function logout() {
    try {
        await authenticate.logout();
    } catch (error) {
        console.error('Erreur lors de la déconnexion :', error);
    }
}
